import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getFilters } from '../../common/config/filters';
import { certificationBadgeResolver, isEcosystemCloudApp } from '../../common/utils/hitsStatsHelper';
import { LARGE_COLLECTION_TYPE } from '../config/discoverCollections';
import { ANALYTICS_SUBJECT_ID_DISCOVER_TILES, ANALYTICS_SUBJECT_ID_SEARCH_TILES, EVENT_CHANNEL, EVENT_SOURCE, OBJECT_TYPE_APP, TilesRenderedEvent } from '../constants/analytics/events';
let rank = 1;
const getAllAppTilesData = (appTiles, isContinuation) => {
  // if more tiles of some other search is rendered, rank will restart from 1
  if (!isContinuation) {
    rank = 1;
  }
  let totalEcosystemCloudAppTiles = 0;
  const allAppKeys = appTiles.map((tile, i) => {
    let isCloudApp = false;
    if (isEcosystemCloudApp(tile)) {
      totalEcosystemCloudAppTiles++;
      isCloudApp = true;
    }
    return {
      key: tile.addonKey,
      rank: rank + i,
      isEcosystemCloudApp: isCloudApp
    };
  });
  rank = rank + allAppKeys.length;
  return {
    appKeys: allAppKeys,
    totalEcosystemCloudAppTiles
  };
};
const getDiscoverAppTilesData = (discoverData, collectionData) => {
  let totalEcosystemCloudAppTiles = 0;
  let allAppKeysData = [];
  Object.keys(discoverData).forEach(key => {
    const currentCollectionTiles = discoverData[key].hits;
    const currentAppKeysData = currentCollectionTiles.map((tile, i) => {
      let isCloudApp = false;
      if (isEcosystemCloudApp(tile)) {
        totalEcosystemCloudAppTiles++;
        isCloudApp = true;
      }
      return {
        key: tile.addonKey,
        rank: i + 1,
        tileType: collectionData.get(key) === LARGE_COLLECTION_TYPE ? 'large' : 'small',
        isEcosystemCloudApp: isCloudApp,
        collectionName: key
      };
    });
    allAppKeysData = [...allAppKeysData, ...currentAppKeysData];
  });
  return {
    appKeys: allAppKeysData,
    totalEcosystemCloudAppTiles
  };
};
const getSearchTileCounts = (oldSearchData, newSearchData, featureFlags) => {
  const {
    enableCloudFortifiedAppsDiscovery
  } = featureFlags;
  const oldHits = oldSearchData.searchResults.hits;
  const newHits = newSearchData.searchResults.hits;
  const incrementalTilesRendered = oldSearchData !== null && oldSearchData !== void 0 && oldSearchData.loadingFreshSearchResults ? newHits : newHits.slice(oldHits.length);
  const isContinuation = !(oldSearchData !== null && oldSearchData !== void 0 && oldSearchData.loadingFreshSearchResults);
  const {
    hasCloudFortifiedBadge,
    hasCloudSecurityBadge
  } = certificationBadgeResolver(enableCloudFortifiedAppsDiscovery);
  const incrementalTilesRenderedWithCloudSecurityBadge = incrementalTilesRendered.filter(hasCloudSecurityBadge);
  const incrementalTilesRenderedWithCloudFortifiedBadge = incrementalTilesRendered.filter(hasCloudFortifiedBadge);
  const {
    appKeys,
    totalEcosystemCloudAppTiles
  } = getAllAppTilesData(incrementalTilesRendered, isContinuation);
  return {
    totalTiles: incrementalTilesRendered.length,
    totalTilesWithCloudSecurityBadge: incrementalTilesRenderedWithCloudSecurityBadge.length,
    totalTilesWithCloudFortifiedBadge: incrementalTilesRenderedWithCloudFortifiedBadge.length,
    appKeys,
    totalEcosystemCloudAppTiles
  };
};
const getDiscoverTileCounts = (discoverData, featureFlags, collectionData) => {
  const {
    enableCloudFortifiedAppsDiscovery
  } = featureFlags;
  let allTiles = [];
  Object.keys(discoverData).forEach(key => {
    allTiles = [...allTiles, ...discoverData[key].hits];
  });
  const totalTiles = allTiles.length;
  const {
    hasCloudFortifiedBadge,
    hasCloudSecurityBadge
  } = certificationBadgeResolver(enableCloudFortifiedAppsDiscovery);
  const totalTilesWithCloudSecurityBadge = allTiles.filter(hasCloudSecurityBadge).length;
  const totalTilesWithCloudFortifiedBadge = allTiles.filter(hasCloudFortifiedBadge).length;
  const {
    appKeys,
    totalEcosystemCloudAppTiles
  } = getDiscoverAppTilesData(discoverData, collectionData);
  return {
    totalTiles,
    totalTilesWithCloudSecurityBadge,
    totalTilesWithCloudFortifiedBadge,
    appKeys,
    totalEcosystemCloudAppTiles
  };
};
const fireAnalyticsEvent = createAnalyticsEvent => (actionSubjectId, objectId, attribute, source) => {
  createAnalyticsEvent({
    eventType: TilesRenderedEvent,
    objectType: OBJECT_TYPE_APP,
    source,
    objectId,
    actionSubjectId,
    attributes: _objectSpread(_objectSpread({}, attribute), {}, {
      sourceComponent: EVENT_SOURCE
    })
  }, EVENT_CHANNEL);
};
export const trackTileRenders = (props, newProps) => {
  var _props$discoverCollec, _props$discoverCollec2;
  const oldSearchData = props.search;
  const newSearchData = newProps.search;
  const oldHits = oldSearchData.getIn(['searchResults', 'hits']);
  const newHits = newSearchData.getIn(['searchResults', 'hits']);
  const oldDiscoverData = props.discover.get('data');
  const newDiscoverData = newProps.discover.get('data');
  const fireEvent = fireAnalyticsEvent(props.fireAnalyticsEvent);
  const searchTerm = newProps.filters.get(getFilters().getIn(['query', 'key']));
  const filters = newProps.filters.toJS();
  const featureFlags = {
    enableCloudFortifiedAppsDiscovery: props.enableCloudFortifiedAppsDiscovery
  };
  const collectionData = new Map();
  props === null || props === void 0 ? void 0 : (_props$discoverCollec = props.discoverCollectionsConfig) === null || _props$discoverCollec === void 0 ? void 0 : (_props$discoverCollec2 = _props$discoverCollec.get(props.filters.get('product', 'home'))) === null || _props$discoverCollec2 === void 0 ? void 0 : _props$discoverCollec2.map(collection => {
    collectionData.set(collection.get('key'), collection.get('type'));
  });
  if (newDiscoverData && newDiscoverData !== oldDiscoverData) {
    fireEvent(ANALYTICS_SUBJECT_ID_DISCOVER_TILES, 0, getDiscoverTileCounts(newDiscoverData.toJS(), featureFlags, collectionData), newProps.perspective);
  } else if (newHits && newHits !== oldHits) {
    fireEvent(ANALYTICS_SUBJECT_ID_SEARCH_TILES, newSearchData.get('currentPage'), _objectSpread(_objectSpread({}, getSearchTileCounts(oldSearchData.toJS(), newSearchData.toJS(), featureFlags)), {}, {
      searchTerm,
      filters
    }), newProps.perspective);
  }
};